import React, { useEffect } from "react";
import useValidation from "../shared/useValidation";
import "./ChangeOnePart.scss";
import ChangeOnePart from "./versions/ChangeOnePart";

export default function ChangeOnePartValidation(props) {

  const isValid = useValidation(props.version, props.wordMetadata, {
    1: ["PHON", "GRAPHEMIC_BREAKDOWN", "SUBS", "SUB_POSITION"],
    2: ["PHON", "GRAPHEMIC_BREAKDOWN", "SUBS", "SUB_POSITION"],
  });

  useEffect(() => {
    if (!isValid) close();
  }, []);

  if (!isValid) return null;

  const Version = {
    1: ChangeOnePart,
    2: ChangeOnePart
  }[props.version];

  return (
    <Version
      {...props}
      close={close}
      dispatchEvent={dispatchEvent}
      versionId={props.version}
    />
  );

  function dispatchEvent(event) {
    props.handleMessage({
      event,
    });
  }

  function close() {
    props.handleMessage({
      continueWithoutSpeaking: true,
      endOfPhrase: props.endOfPhrase,
    });
  }
}
